/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 12.07.13
 * Time: 10:49
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class CookieLogLOFactory extends BasicLogObjectFactory {
    public static COOKIE_PENDING_FAILED: number = 4003;

    private static COOKIE_ERROR: number = 4;

    constructor(subErrorId: number) {
        super();

        this._subErrorId = subErrorId;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Set custom data
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_TYPE, ExternalLoggingConstants.LOGGING_TYPE_LOG.toString());
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, CookieLogLOFactory.COOKIE_ERROR.toString());

        return lo;
    }
}
